<div class="container">
  <div class="title-content">
    <p>شماره تلفن پشتیبانی کاربران نوار:</p>
  </div>
  <div class="phone-content">
    <b dir="ltr" style="margin: 0 8px; text-align: left">021 - 91004741</b>
    <b style="margin: 0 8px">داخلی ۱</b>
  </div>
  <div class="wrapper-button-actions">
    <button
      class="button-actions"
      (click)="onCloseModal()"
    >
      بستن
    </button>
  </div>
</div>
